<template>
  <div v-if="product" class="product-container containerg pagina_produs">
    <div class="product-left">
      <img v-if="product.image" :src="product.image" alt="Produs" />
    </div>
    <div class="product-right">
      <h1>{{ product.name }}</h1>
      <div v-html="product.description"></div>

      <div class="box_pret_container" v-if="product.discount > 0">
        <div class="pret_produs_modal_taiat">{{ product.price }} lei</div>
        <div class="ppp">{{ product.price_final }} lei</div>
      </div>
      <div class="box_pret_container" v-else>
        <div class="ppp">{{ product.price }} lei</div>
      </div>

      <div v-if="alergeni_ro !='' && $i18n.locale == 'ro'" class="alergeni">
        <div class="titlu_alergeni">Alergeni:</div>
        <div class="cuprins_alergeni">{{alergeni_ro}}</div>
      </div>
      <div v-else-if="alergeni_en !='' && $i18n.locale == 'en'" class="alergeni">
        <div class="titlu_alergeni">Allergens:</div>
        <div class="cuprins_alergeni">{{alergeni_en}}</div>
      </div>
      <div v-else class="alergeni">
      </div>

      <div class="extra_modal" v-if="optiuni_extra.length > 1">
        <div class="titlu_extra_modal">{{ $t('alege_optiuni') }}</div>
        <div class="container_checkbox">
          <label v-for="(iii,index) in optiuni_extra" :key="iii.external_id" :index="index" class="container checkbox_flex opt_extra" :dataname="iii.text">
            <div class="nume_extra" v-if="$i18n.locale == 'ro'">{{iii.text}}</div>
            <div class="nume_extra" v-else>{{iii.text}}</div>
            <input type="radio" name="checkbox_optiune" :checked="index == 0" class="checkbox_optiune" @click="()=>{selectOptiune(iii.text,iii.external_id,id_produs)}" :value="[iii.text,iii.external_id,id_produs]">
            <span class="checkmark"></span>
          </label>
        </div> 
      </div>

      <div class="extra_modal">
        <div class="titlu_extra_modal" v-if="ingrediente_extra.length > 0">{{ $t('adauga_ingrediente') }}</div>
        <div class="container_checkbox">
          <label v-for="ie in ingrediente_extra" :key="ie.id" class="container checkbox_flex prod_extra" :dataname="ie.name_ro" :datapret="ie.price">
            <div class="nume_extra" v-if="$i18n.locale == 'ro'">{{ie.name_ro}}</div>
            <div class="nume_extra" v-else>{{ie.name_en}}</div>
            <input type="checkbox" @click="()=>{selectExtra(ie.name_ro,ie.price,ie.id,id_produs)}" :value="[ie.name_ro,ie.price,ie.id,id_produs]">
            <span class="checkmark"></span>
            <div class="pret_extra">{{ie.price}} lei</div>
          </label>
        </div> 
      </div>

      <div class="title_box_livrare">
        <div class="title_livrare">{{ $t('nota_produs_individual') }}</div>
        <textarea 
          rows="2" 
          maxlength="150" 
          class="nota_produs_individual" 
          v-model="nota_produs_individual">
        </textarea>
      </div>

      <div v-if="$store.state.status_bucatarie === '1' || ($store.state.status_bucatarie === '2' && product.preparing_time === 'Fast')" class="adauga_produs_modal">
        <div class="nr_produse_modal">
            <font-awesome-icon v-on:click="countMinus()" :icon="{ prefix: 'fas', iconName: 'minus' }" class="minus_plus minus_modal"/>
            <div class="numar_modal">{{ count }}</div>
            <font-awesome-icon v-on:click="count++" :icon="{ prefix: 'fas', iconName: 'plus' }" class="minus_plus plus_modal"/>
        </div>
        
        <div class="adauga_cos_modal" :dataid="id_produs"  @click="adaugaProdusInCos">{{ $t('adauga_in_cos') }}</div>
      </div>
      <div v-else-if="$store.state.status_bucatarie === '2' && product.preparing_time === 'Normal'" class="mesaj_bucatarie_inchisa">
        <div>{{ msg_status_Fast_ro }}</div>
      </div>
      <div v-else-if="$store.state.status_bucatarie === '0'" class="">
        <div>{{ msg_status_Closed_ro }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import $ from 'jquery'

export default {
  data() {
    return {
      product: null,
      qty: 1,
      count: 1,
      produse_extra: [],
      nota_produs_individual: '',
      msg_status_Fast_ro: 'Momentan nu putem prepara acest produs.',
      msg_status_Closed_ro: 'Serviciul de livrare este închis momentan. Te rugăm să revii luni-joi între 10-24, vineri-sâmbăta între 10-01, duminică între 12-24. Pentru informații și ajutor, ne poți suna la 0747 247 876 :)',
      // Adăugate pentru a preveni undefined
      nume_produs: '',
      descriere_produs: '',
      nume_produs_en: '',
      descriere_produs_en: '',
      imagine_produs: '',
      pret: 0,
      preparing_time: '',
      discount_procent: 0,
      discount_price_final: 0,
      categorii_standard_produs: [],
      optiuni_extra_produs: [],
      external_id: '',
      alergeni_en: '',
      alergeni_ro: '',
      ingrediente_extra: [],
      id_produs: null,
    }
  },
  async created() {
    const slug = this.$route.params.slug;

    try {
      const response = await axios.get(`https://xpanel.tikibistro.ro/api/products/getProductBySlug/${slug}`, {
        withCredentials: false
      });

      const data = response.data.data[0];

      if (!data) {
        this.$router.replace('/404');
        return;
      }

      this.product = {
        name: data.additional.name_ro,
        description: data.additional.description_ro,
        image: (data.main_image && data.main_image.length > 0) ? data.main_image[0].resizedpath : (data.images && data.images.length > 0) ? data.images[0].resizedpath : null,
        price: data.price,
        price_final: data.price_final,
        discount: data.discount,
        alergeni: data.alergeni_ro,
        attributes: data.attributes || [],
        options: data.options || [],
      };

      // Inserted assignments after setting this.product
      this.nota_produs_individual = "";
      this.$set(this, 'nume_produs', data.additional.name_ro);
      this.descriere_produs = data.additional.description_ro;
      this.nume_produs_en = data.additional.name_en;
      this.descriere_produs_en = data.additional.description_en;
      this.preparing_time = data.preparing_time;
      this.discount_procent = data.discount;
      this.discount_price_final = data.price_final;
      this.categorii_standard_produs = data.categories;

      if (data.images && data.images.length > 0) {
        this.array_imagini_produs = data.images;
        this.imagine_produs = (data.main_image && data.main_image.length > 0) ? data.main_image[0].resizedpath : null;
      } else {
        this.array_imagini_produs = [];
        this.imagine_produs = '/img/about_us_1.1c8c627b.png';
      }

      this.pret = data.price;
      this.alergeni_en = data.alergeni_en;
      this.alergeni_ro = data.alergeni_ro;
      this.ingrediente_extra = data.attributes;
      this.optiuni_extra = data.options;
      this.id_produs = data.id;

      if (data.options && data.options.length > 0) {
        this.external_id = data.options[0].external_id;
        this.optiuni_extra_produs = [data.options[0].text, data.options[0].external_id];
      }

    } catch (error) {
      console.error("Eroare la încărcarea produsului:", error);
    }
  },
  metaInfo() {
    const descriereRo = this.nume_produs ? `Comandă online ${this.nume_produs} de la TikiBistro. Livrare rapidă și gust autentic.` : '';
    const descriereEn = this.nume_produs_en ? `Order ${this.nume_produs_en} online from TikiBistro. Fast delivery and authentic taste.` : '';
    const titluRo = this.nume_produs ? `${this.nume_produs} - TikiBistro` : 'Produs Tiki Bistro';
    const titluEn = this.nume_produs_en ? `${this.nume_produs_en} - TikiBistro` : 'Product Tiki Bistro';
    const currentLang = this.$i18n.locale;

    console.log(this.nume_produs);

    return {
      title: currentLang === 'ro' ? titluRo : titluEn,
      meta: [
        {
          name: 'description',
          content: currentLang === 'ro' ? descriereRo : descriereEn
        },
        {
          property: 'og:title',
          content: currentLang === 'ro' ? titluRo : titluEn
        },
        {
          property: 'og:description',
          content: currentLang === 'ro' ? descriereRo : descriereEn
        },
        {
          property: 'og:image',
          content: this.imagine_produs
        },
        {
          property: 'og:url',
          content: typeof window !== 'undefined' ? window.location.href : ''
        },
        {
          name: 'robots',
          content: 'index,follow'
        }
      ]
    };
  },
  methods: {
    addToCart() {
      alert(`Adăugat ${this.qty}x ${this.product.name} în coș`);
      // TODO: integrează logica reală de adăugare în coș
    },
    countMinus() {
      if (this.count > 1) {
        this.count--;
      }
    },
    adaugaProdusInCos() {
      if (!this.id_produs) {
        alert('Acest produs nu este disponibil.');
        return;
      }

      let total_extra = 0;
      if (this.produse_extra.length > 0) {
        const total = Object.values(this.produse_extra).map(val => val[1]);
        total_extra = total.reduce((acc, val) => acc + val, 0);
      }

      const produs_cos = {
        id_produs: this.id_produs,
        nume_produs: this.nume_produs,
        descriere_produs: this.descriere_produs,
        nume_produs_en: this.nume_produs_en,
        descriere_produs_en: this.descriere_produs_en,
        poza_produs: this.imagine_produs,
        cantitate_produs: this.count,
        pret_produs: this.pret,
        discount_price_final: this.discount_price_final,
        discount_procent: this.discount_procent,
        produse_extra: this.produse_extra || [],
        external_id: this.external_id,
        total_extra: total_extra,
        total_produs: this.pret + total_extra,
        preparing_time: this.preparing_time,
        optiuni_extra_produs: this.optiuni_extra_produs || [],
        nota_produs_individual: this.nota_produs_individual || '',
        categorii_standard_produs: this.categorii_standard_produs || []
      };

      console.log("Trimite spre vuex:", produs_cos);

      this.$store.commit('adaugaInCos', produs_cos);

      // animatie
      $('.modal_confirmare').animate({ right: /Android|iPhone|iPad/.test(navigator.userAgent) ? "10px" : "20px" }, "slow");
      setTimeout(() => {
        $('.modal_confirmare').animate({ right: /Android|iPhone|iPad/.test(navigator.userAgent) ? "-1000px" : "-100vw" }, "slow");
      }, 2000);

      this.produse_extra = [];
      $('.prod_extra input[type=checkbox]').prop('checked', false);
    },
    selectOptiune(nume, id, id_produs) {
      var array_optiuni_extra = [];
      array_optiuni_extra.push(nume, id);
      this.optiuni_extra_produs = array_optiuni_extra;
    },
    selectExtra(nume, pret, id, id_produs) {
      var produsul_exista = false;
      var that = this;
      if (this.produse_extra.length > 0) {
        $.each(this.produse_extra, function (key, value) {
          var id_produs_isset = value[3];
          var id_extra_isset = value[2];

          if (id_produs_isset == id_produs && id_extra_isset == id) {
            produsul_exista = true;
            that.produse_extra.splice(key, 1);
            return false;
          }
        });
      }

      if (produsul_exista == false) {
        var array_extra = [nume, pret, id, id_produs];
        this.produse_extra.push(array_extra);
      }
    }
  },
  
}
</script>
